import { logger } from "@nosto/search-js/utils"

const localStorageKey = "search-templates-ga-event"

type GaNamespace = {
    (): void
    getAll(): {
        send(type: string, url: string): void
    }[]
}

function hasGtag(window: Window): window is Window & { gtag: (...args: unknown[]) => void } {
    return "gtag" in window && typeof window.gtag === "function"
}

function hasGa(window: Window): window is Window & { ga: GaNamespace } {
    return (
        "ga" in window &&
        typeof window.ga === "function" &&
        "getAll" in window.ga &&
        typeof window.ga.getAll === "function"
    )
}

function hasGoogleTagManager(window: Window): window is Window & { google_tag_manager: Record<string, unknown> } {
    return "google_tag_manager" in window && typeof window.google_tag_manager === "object"
}

export function trackGaPageView(options?: { delay?: boolean; title?: string; location?: string }) {
    const { delay = false, title = document.title, location = window.location.href } = options || {}

    if (delay) {
        saveToLocalStorage(title, location)
    } else {
        if (hasGtag(window)) {
            const accounts = Object.keys(hasGoogleTagManager(window) ? window.google_tag_manager : {}).filter(
                e => e.substring(0, 2) == "G-"
            )

            if (accounts.length > 1) {
                for (let i = 0; i < accounts.length; i++) {
                    window.gtag("event", "page_view", {
                        page_title: title,
                        page_location: location,
                        send_to: accounts[i]
                    })
                }
            } else {
                window.gtag("event", "page_view", {
                    page_title: title,
                    page_location: location
                })
            }
        }
        if (hasGa(window)) {
            try {
                const url = new URL(location)
                const trackers = window.ga!.getAll()
                if (trackers?.length > 0) {
                    trackers[0]?.send("pageview", url.pathname + url.search)
                }
            } catch (error) {
                logger.warn("Could not send pageview to GA", error)
            }
        }
    }
}

function saveToLocalStorage(title: string, location: string): void {
    localStorage.setItem(localStorageKey, JSON.stringify({ title, location }))
}

interface Event {
    title: string
    location: string
}

function consumeLocalStorageEvent(): void {
    const eventString = localStorage.getItem(localStorageKey)
    if (typeof eventString === "string") {
        localStorage.removeItem(localStorageKey)
        try {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const event: Event = JSON.parse(eventString)
            trackGaPageView(event)
        } catch (e) {
            logger.warn(e)
        }
    }
}

setTimeout(consumeLocalStorageEvent, 1000)
